import * as React from "react";

import classNames from "classnames";

import Markdown from "react-markdown";

import { replaceCustomFieldWithCustomEntries } from "../../src/activities";

import {
  applyState,
} from "../../src/state";

import DocOpenAiMessageBar from "../Doc/OpenAiMessageBar";

interface ActivityReviewSummaryProps {
  activity: ActivitySnakeModel
  activityUserState: ActivityUserStateSnakeModel
  documentMediaFolder: string
}

export default function ActivityReviewSummary(props: ActivityReviewSummaryProps) {
  const {
    activity,
    activityUserState,
    documentMediaFolder,
  } = props;

  return (
    renderContent(activity.content.flat(), activityUserState, documentMediaFolder)
  );
}

function renderContent(content: BlockContent[], activityUserState: ActivityUserStateSnakeModel, documentMediaFolder: string) {
  return content.map((node) => {
      let suggestedResponse;
      if ("feedback" in node) {
        suggestedResponse = (
          <div>
            <b>Correct Answer:</b>
            <div className="suggested-response">
              {node.feedback}
            </div>
          </div>
        );
      }

      switch (node.type) {
        case "paragraph": {
          return (
            <p
              key={node.uid}
              dangerouslySetInnerHTML={{__html: node.content}}
              style={{marginBottom: "20px"}}
            />
          );
        }
        case "regularList": {
          return (
            <ul key={node.uid} className="list-inside" style={{marginBottom: "20px"}}>
              {
                node.content.map((listItem) => (
                  <li
                    key={listItem.uid}
                    className="doc-list-item list-disc"
                  >
                    <span
                      key={listItem.uid}
                      dangerouslySetInnerHTML={{__html: listItem.content}}
                      style={{marginBottom: "20px"}}
                    />
                  </li>
                ))
              }
            </ul>
          )
        }
        case "numberedList": {
          return (
            <ol key={node.uid} className="list-inside" style={{marginBottom: "20px"}}>
              {
                node.content.map((listItem) => (
                  <li
                    key={listItem.uid}
                    className="doc-list-item list-decimal"
                  >
                    <span
                      key={listItem.uid}
                      dangerouslySetInnerHTML={{__html: listItem.content}}
                      style={{marginBottom: "20px"}}
                    />
                  </li>
                ))
              }
            </ol>
          )
        }
        case "textInput": {
          return (
            <div key={node.uid} style={{marginBottom: "20px"}}>
              <b>Student Response:</b>
              <div className="student-response">
                <p>{activityUserState && activityUserState.state[node.uid]?.value?.value as string}</p>
              </div>
              {suggestedResponse}
            </div>
          );
        }
        case "multipleChoice": {
          const answeredValues = node.content.map((multipleChoiceAnswer) => {
            const answered = activityUserState && activityUserState.state[multipleChoiceAnswer.uid]?.value?.value;

            return (
              <li
                key={multipleChoiceAnswer.uid}
                className={
                  classNames(
                    "doc-multiple-choice-answer",
                    multipleChoiceAnswer.answer ? "correct" : "incorrect",
                    {answered},
                  )
                }
              >
                <span className="doc-multiple-choice-answer-outer"><span className="doc-multiple-choice-answer-inner" /></span>
                <span className="doc-multiple-choice-answer-title">{multipleChoiceAnswer.content}</span>
                {(multipleChoiceAnswer.value || multipleChoiceAnswer.answer) && (
                  <span style={{marginLeft: "10px"}}>
                    {multipleChoiceAnswer.answer ? <i className="fa fa-check text-green-600" /> : <i className="fa fa-xmark text-red-700" /> }
                  </span>
                )}
              </li>
            );
          });

          return (
            <div key={node.uid}>
              <b>Student Response:</b>
              <div className="student-response">
                <ul>
                  {answeredValues}
                </ul>
              </div>
              {suggestedResponse}
            </div>
          );
        }
        case "openAiChat": {
          const state = activityUserState?.state || {}
          const nodeWithState = applyState(node, state)

          return (
            <div key={node.uid}>
              <b>Student Response:</b>
              <div className="student-response">
                {nodeWithState.messages?.map((message, i) => (
                  <DocOpenAiMessageBar
                    key={`message-${i}`}
                    role={message.role}
                    name={(message.role === "assistant") ? node.assistantDisplayName || "Assistant" : "Student"}
                    // imageSrc={displayImageSrcFromAiRole(documentMediaFolder, message.role === "assistant" ? nodeWithState.assistantDisplayImage : nodeWithState.userDisplayImage, activity.custom_entries)}
                    content={
                      message.role === "assistant" ?
                        <Markdown>{message.content}</Markdown> :
                        message.content.split(/\n/).map((paragraph, i) => <p key={i}>{paragraph}</p>)
                    }
                  />
                ))}
              </div>
            </div>
          )
        }
        case "section": {
          return (
            <div key={node.uid}>
              <h2>{node.title}</h2>
              <div>{renderContent(node.content, activityUserState, documentMediaFolder)}</div>
            </div>
          )
        }
        default:
          console.log(node.type)
          return null;
          // TODO ADD ERROR
      }
    })
}

function displayImageSrcFromAiRole(mediaFolder: string, imageFileName: string, currentActivityCustomEntries: Record<string, string> ) {
  return imageFileName && `${mediaFolder}/compressed/images/${replaceCustomFieldWithCustomEntries(imageFileName, currentActivityCustomEntries)}`
}
